// Strona produktu: darmowa dostawa i pasek zakupu na telefonie
(() => {
  const fmt = (cents) => (cents / 100).toFixed(2) + ' zł';

  function parts(sectionId) {
    return {
      sectionId,
      selects: document.getElementById('variant-selects-' + sectionId),
      sticky: document.getElementById('MmSticky-' + sectionId),
      sheet: document.getElementById('MmSheet-' + sectionId),
      ship: document.querySelector('#ProductInfo-' + sectionId + ' [data-mm-ship]'),
      form: document.getElementById('product-form-' + sectionId),
    };
  }

  function variants(p) {
    if (p._variants) return p._variants;
    const json = p.selects && p.selects.querySelector('script[type="application/json"]');
    p._variants = json ? JSON.parse(json.textContent) : [];
    return p._variants;
  }

  function initialVariant(p) {
    const input = p.form && p.form.querySelector('input[name="id"]');
    const found = input && variants(p).find((v) => String(v.id) === input.value);
    if (found) return found;
    if (!p.sticky) return null;
    return { price: Number(p.sticky.dataset.price), available: p.sticky.dataset.available === 'true' };
  }

  function quantity(p) {
    const input = p.form && p.form.closest('product-info');
    const q = input && input.querySelector('input[name="quantity"]');
    return Math.max(1, Number(q && q.value) || 1);
  }

  function updateShip(p, variant, cartOnly) {
    if (!p.ship) return;
    const threshold = Number(p.ship.dataset.threshold);
    const cart = Number(p.ship.dataset.cart);
    const total = cartOnly || !variant ? cart : cart + variant.price * quantity(p);
    const missing = threshold - total;
    const free = missing <= 0;
    const text = p.ship.querySelector('[data-mm-ship-text]');
    const bar = p.ship.querySelector('[data-mm-ship-bar]');
    const lead = cartOnly ? 'Masz' : 'Z tym produktem masz';
    const need = cartOnly ? 'Brakuje Ci' : 'Z tym produktem brakuje Ci';
    text.textContent = '';
    const strong = document.createElement('strong');
    strong.textContent = free ? 'darmową dostawę' : fmt(missing);
    text.append((free ? lead : need) + ' ', strong);
    if (!free) text.append(' do darmowej dostawy');
    p.ship.classList.toggle('is-free', free);
    const width = Math.min(100, Math.floor((total * 100) / threshold)) + '%';
    bar.style.width = width;
    const line = p.sticky && p.sticky.querySelector('[data-mm-sticky-ship]');
    if (line) line.style.width = width;
  }

  // Wybrane wartości opcji odczytane z głównego formularza
  function selection(p) {
    if (!p.sheet) return [];
    const count = Number(p.sheet.dataset.options);
    const out = [];
    for (let i = 0; i < count; i++) {
      const select = document.getElementById('Option-' + p.sectionId + '-' + i);
      if (select) {
        out.push(select.value);
        continue;
      }
      const group = p.sheet.querySelector('[data-mm-option="' + i + '"]');
      const name = group ? group.dataset.name : p.sheet.dataset['option' + i];
      const radio =
        name && p.selects.querySelector('input[type="radio"][name="' + CSS.escape(name) + '"]:checked');
      out.push(radio ? radio.value : '');
    }
    return out;
  }

  // Zdjęcie wariantu, a gdy go nie ma: zdjęcie innego rozmiaru w tym samym kolorze
  function variantImage(p, variant) {
    if (variant.featured_image) return variant.featured_image;
    const sameColor = variants(p).find((v) => v.featured_image && v.option1 === variant.option1);
    return sameColor ? sameColor.featured_image : null;
  }

  function updateStickyImage(p, variant) {
    const img = p.sticky.querySelector('.mm-sticky__img');
    const image = variant && variant.options ? variantImage(p, variant) : null;
    if (!img || !image) return;
    const src = image.src + (image.src.includes('?') ? '&' : '?') + 'width=120';
    if (img.getAttribute('src') !== src) img.src = src;
  }

  function updateSheet(p) {
    if (!p.sheet) return;
    const chosen = selection(p);
    p.sheet.querySelectorAll('[data-mm-option]').forEach((group) => {
      const index = Number(group.dataset.mmOption);
      const label = group.querySelector('[data-mm-sheet-value]');
      if (label) label.textContent = chosen[index];
      group.querySelectorAll('[data-value]').forEach((button) => {
        const value = button.dataset.value;
        const active = value === chosen[index];
        const available = variants(p).some(
          (v) => v.available && v.options[index] === value && v.options.every((o, i) => i === index || o === chosen[i])
        );
        button.setAttribute('aria-pressed', active);
        button.classList.toggle('is-unavailable', !available);
      });
    });
  }

  function updateSticky(p, variant, unavailable) {
    const s = p.sticky;
    if (!s || (!variant && !unavailable)) return;
    const price = s.querySelector('[data-mm-sticky-price]');
    const label = s.querySelector('[data-mm-sticky-variant-text]');
    const btn = s.querySelector('[data-mm-sticky-btn]');
    const mainBtn = p.form && p.form.querySelector('.product-form__submit');
    if (variant) {
      price.textContent = fmt(variant.price);
      if (label && variant.title) label.textContent = variant.title.split(' / ').join(' · ');
      updateStickyImage(p, variant);
      btn.disabled = !variant.available;
    } else {
      const chosen = selection(p);
      if (label) label.textContent = chosen.join(' · ');
      updateStickyImage(p, variants(p).find((v) => v.option1 === chosen[0]));
      btn.disabled = true;
    }
    if (mainBtn) btn.textContent = mainBtn.textContent.trim();
    updateSheet(p);
  }

  function setOption(p, index, name, value) {
    const select = document.getElementById('Option-' + p.sectionId + '-' + index);
    if (select) {
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    const radio = p.selects.querySelector(
      'input[type="radio"][name="' + CSS.escape(name) + '"][value="' + CSS.escape(value) + '"]'
    );
    if (radio) radio.click();
  }

  function initSheet(p) {
    const s = p.sticky;
    const sheet = p.sheet;
    const opener = s.querySelector('[data-mm-sticky-variant]');
    if (!sheet || !opener) return;

    // Motyw po zmianie wariantu przewija do galerii. Z otwartego panelu klient zostaje tam, gdzie był.
    const nativeScrollTo = window.scrollTo.bind(window);
    window.scrollTo = (...args) => {
      if (!p.sheetOpen) nativeScrollTo(...args);
    };

    const open = () => {
      sheet.style.setProperty('--mm-sticky-height', s.offsetHeight + 'px');
      updateSheet(p);
      sheet.hidden = false;
      opener.setAttribute('aria-expanded', 'true');
      p.sheetOpen = true;
      sheet.querySelector('[data-mm-sheet-close]').focus({ preventScroll: true });
    };
    p.closeSheet = () => {
      if (!p.sheetOpen) return;
      sheet.hidden = true;
      opener.setAttribute('aria-expanded', 'false');
      p.sheetOpen = false;
      if (s.classList.contains('is-visible')) opener.focus({ preventScroll: true });
      if (p.applyStickyVisibility) p.applyStickyVisibility();
    };

    opener.addEventListener('click', () => (p.sheetOpen ? p.closeSheet() : open()));
    sheet.addEventListener('click', (event) => {
      if (event.target.closest('[data-mm-sheet-close]')) {
        p.closeSheet();
        return;
      }
      const button = event.target.closest('[data-value]');
      if (!button) return;
      const group = button.closest('[data-mm-option]');
      setOption(p, Number(group.dataset.mmOption), group.dataset.name, button.dataset.value);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') p.closeSheet();
    });
    s.querySelector('[data-mm-sticky-btn]').addEventListener('click', () => p.closeSheet());
  }

  function initSticky(p) {
    const s = p.sticky;
    const mainBtn = p.form && p.form.querySelector('.product-form__submit');
    if (!s || !mainBtn || !('IntersectionObserver' in window)) return;
    let show = false;
    p.applyStickyVisibility = () => {
      if (p.sheetOpen) return;
      s.classList.toggle('is-visible', show);
      s.inert = !show;
      document.body.classList.toggle('mm-sticky-on', show);
    };
    const observer = new IntersectionObserver(([entry]) => {
      show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      if (show && p.sheet) p.sheet.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
      p.applyStickyVisibility();
    });
    observer.observe(mainBtn);
    // Motyw zmienia główny przycisk dopiero po pobraniu danych wariantu, pasek idzie za nim
    const btn = s.querySelector('[data-mm-sticky-btn]');
    new MutationObserver(() => {
      const current = p.form.querySelector('.product-form__submit');
      if (!current) return;
      const text = current.textContent.trim();
      if (text && btn.textContent !== text) btn.textContent = text;
      if (btn.disabled !== current.disabled) btn.disabled = current.disabled;
    }).observe(p.form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    initSheet(p);
  }

  document.querySelectorAll('[data-mm-pdp]').forEach((root) => {
    const p = parts(root.dataset.mmPdp);
    const v = initialVariant(p);
    updateShip(p, v);
    updateSticky(p, v);
    initSticky(p);

    if (p.selects) {
      p.selects.addEventListener('change', () => {
        setTimeout(() => {
          const current = p.selects.currentVariant;
          if (!current) {
            updateSticky(p, null, true);
            return;
          }
          updateShip(p, current);
          updateSticky(p, current);
        }, 0);
      });
    }

    const qty = p.form && p.form.closest('product-info') && p.form.closest('product-info').querySelector('input[name="quantity"]');
    if (qty) {
      const onQty = () => updateShip(p, (p.selects && p.selects.currentVariant) || initialVariant(p));
      qty.addEventListener('change', onQty);
      qty.addEventListener('input', onQty);
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        fetch('/cart.js')
          .then((r) => r.json())
          .then((cart) => {
            if (!p.ship) return;
            p.ship.dataset.cart = cart.total_price;
            updateShip(p, null, true);
          })
          .catch(() => {});
      });
    }
  });
})();
